module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-potworowska-pluciennik-ec60b84cb9c2dfbd3d8206dfff13a3bf.png";